export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/new-invite-register' */ './NewInviteRegister'
  );
